import * as React from "react";

function Requisition({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 17" fill="none" {...props}>
      <path
        d="M17.247 3a.917.917 0 01.916-.917h10.082a.916.916 0 110 1.833H18.163A.917.917 0 0117.247 3zm10.998 4.582H18.163a.917.917 0 100 1.833h10.082a.916.916 0 100-1.833zm0 5.499h-7.332a.916.916 0 100 1.833h7.332a.916.916 0 000-1.833zM17.218 15.6a.919.919 0 01-1.45.954.916.916 0 01-.326-.496c-.706-2.742-3.476-4.811-6.444-4.811-2.969 0-5.739 2.068-6.444 4.811a.917.917 0 01-1.776-.458c.64-2.487 2.502-4.501 4.864-5.499a5.498 5.498 0 116.711 0c2.363.998 4.225 3.012 4.865 5.499zm-8.22-6.186a3.666 3.666 0 100-7.332 3.666 3.666 0 000 7.332z"
        fill={color}
      />
    </svg>
  );
}

export default Requisition;
